define(function(require, exports) {
    'use strict';

    exports.lpAriaNumber = function () {
        return function(input) {
            return input ? String(input).split('').join(' ') : '';
        };
    };
});



//////////////////
// WEBPACK FOOTER
// ./scripts/components/aria/scripts/filters.js
// module id = 59
// module chunks = 0